import { z } from 'zod';
import { TimestampsSchema } from './common.js';
// =============================================================================
// Organization Schema - Tenant container (like Slack workspace)
// =============================================================================
/**
 * Organization types
 */
export const OrganizationTypeEnum = z.enum(['INDIVIDUAL', 'TEAM', 'BROKERAGE']);
/**
 * Billing plan types
 */
export const BillingPlanEnum = z.enum(['FREE', 'PRO', 'ENTERPRISE']);
/**
 * Billing status
 */
export const BillingStatusEnum = z.enum(['ACTIVE', 'PAST_DUE', 'CANCELED', 'TRIALING']);
/**
 * Billing information (Stripe integration)
 */
export const BillingInfoSchema = z.object({
    stripeCustomerId: z.string().optional(),
    stripeSubscriptionId: z.string().optional(),
    stripePriceId: z.string().optional(),
    plan: BillingPlanEnum.default('FREE'),
    status: BillingStatusEnum.default('ACTIVE'),
    currentPeriodEnd: z.coerce.date().optional(),
    trialStart: z.coerce.date().optional(),
    trialEnd: z.coerce.date().optional(),
    cancelAtPeriodEnd: z.boolean().default(false),
    quantity: z.number().int().default(1),
});
/**
 * Organization branding settings
 */
export const BrandingSettingsSchema = z.object({
    logo: z.string().url().optional(),
    primaryColor: z.string().regex(/^#[0-9A-Fa-f]{6}$/).optional(),
});
/**
 * Organization settings
 */
export const OrganizationSettingsSchema = z.object({
    branding: BrandingSettingsSchema.optional(),
    defaultTimezone: z.string().default('America/Los_Angeles'),
});
/**
 * Full Organization schema (database document)
 */
export const OrganizationSchema = z
    .object({
    _id: z.string(),
    // Basic info
    name: z.string().min(1, 'Organization name is required'),
    type: OrganizationTypeEnum.default('INDIVIDUAL'),
    // Hierarchy (for Brokerage → Team relationships)
    parentId: z.string().optional(),
    // Billing (placeholder)
    billing: BillingInfoSchema.optional(),
    // Settings
    settings: OrganizationSettingsSchema.optional(),
})
    .merge(TimestampsSchema);
/**
 * Organization creation input
 */
export const CreateOrganizationInputSchema = z.object({
    name: z.string().min(1, 'Organization name is required'),
    type: OrganizationTypeEnum.default('INDIVIDUAL'),
    parentId: z.string().optional(),
});
/**
 * Organization update input
 */
export const UpdateOrganizationInputSchema = z.object({
    name: z.string().min(1).optional(),
    settings: OrganizationSettingsSchema.partial().optional(),
});
/**
 * Organization response (safe for client)
 */
export const OrganizationResponseSchema = OrganizationSchema;
//# sourceMappingURL=organization.js.map